// index.jsx
import './style.css'
import ReactDOM from 'react-dom/client'
import App from './App'; // this now includes Canvas

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(<App />);
